var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15714 4.43902C6.75476 4.43902 6.42857 4.76662 6.42857 5.17073V10.7805H13.4714C15.2151 10.7805 16.6286 9.3609 16.6286 7.60976C16.6286 5.85861 15.2151 4.43902 13.4714 4.43902H7.15714ZM17.7031 11.2716C18.5469 10.2889 19.0571 9.00917 19.0571 7.60976C19.0571 4.51157 16.5563 2 13.4714 2H7.15714C5.4135 2 4 3.41959 4 5.17073V18.8293C4 20.5804 5.4135 22 7.15714 22H15.4143C18.4992 22 21 19.4884 21 16.3902C21 14.1111 19.6467 12.1495 17.7031 11.2716ZM6.42857 13.2195V18.8293C6.42857 19.2334 6.75476 19.561 7.15714 19.561H15.4143C17.1579 19.561 18.5714 18.1414 18.5714 16.3902C18.5714 14.6391 17.1579 13.2195 15.4143 13.2195H6.42857Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/Bold.f395bc3f56a3d8dc6b9d1bc43a3db299.svg";
export { ForwardRef as ReactComponent };